import * as React from 'react'
import { Link } from '@amzn/dvui/dist/Link'
import { NavLink } from 'DVWebNodeUtils'
import * as cn from 'classnames'

export interface MenuProps {
  text: string,
  links: NavLink[],
  isElcano: boolean
}

export const MainMenu = ({text, links, isElcano}: MenuProps) => {
  const listItems = links.map((linkProps, i) => {

    const hasSubDropdown: Boolean = Boolean(linkProps.links && linkProps.links.length)
    const subDropdownLinks: JSX.Element[] = hasSubDropdown ? linkProps.links.map((subLink, index) => (
      <li key={`navsublistitem-${index}`} className='subitem'>
        <a href={subLink.href}>{subLink.text}</a>
      </li>
    )) : []
  
    const Dropdown = <>
      {hasSubDropdown ? 
        <li key={i} className="pv-nav-main-menu-subdropdown">
          <input type="checkbox" autoComplete="off" name="pv-nav-main-menu-subdropdown" id="pv-nav-main-menu-subdropdown-trigger"/>
          <label htmlFor="pv-nav-main-menu-subdropdown-trigger" className="pv-nav-main-menu-subdropdown-label">
            <a><span className="pv-nav-main-menu-subdropdown-text">{linkProps.text}</span></a>
          </label>
          {subDropdownLinks && 
          <ul className="pv-nav-main-menu-subdropdown-flyout">
            {subDropdownLinks}
          </ul>}
        </li>
      :
      <li key={i}>
        <Link {...linkProps}
          className={cn({'pv-highlighted': linkProps.isHighlighted})}
          key={linkProps.text} />
      </li>
      }
    </>
  
    return Dropdown
  })

  return (
    <div id="pv-nav-main-menu" className={cn('pv-nav-main-menu', {'pv-nav-main-menu-elcano': isElcano})}>
      <input type="checkbox" autoComplete="off" id="pv-nav-main-menu-trigger"
        className="pv-nav-main-menu-switch avu-screen-reader-only" />
      <label htmlFor="pv-nav-main-menu-trigger" className="pv-nav-main-menu-label">
        {text}
      </label>
      <ul role="navigation">
        {listItems}
      </ul>
    </div>
  )
}
